<template>
	<div class="product-list-page" :style="style">
		<!--<div style="position: absolute; right: -24px; background: red; border-radius: 100%; font-weight: bold; color: white; padding: 2px 9px">
			{{ page }}<br>
			{{ pageHeight }}px
		</div>-->
		<template v-if="! computedHidden">
			<template v-if="productListMode == LIST_MODE_GRID">
				<product-grid-item
					v-for="(product, index) in products"
					class="col-md-4 col-sm-6 col-xs-6"
					:key="'grid-item' + product.id"
					ref="productElements"
					:product="product"
					:pass="pass"
					:showStock="true"
					:categoryIcon="categoryIcon"
					:index="index"
					@handleLinkClick="trackProductClick(product, index)"
					@loaded="setElements()"
				/>
			</template>
			<template v-else-if="productListMode == LIST_MODE_COMPACT">
				<product-list-compact-item
					v-for="(product, index) in products"
					ref="productElements"
					:key="'compact-item' + product.id"
					:product="product"
					:pass="pass"
					:forceShowRelease="forceShowRelease"
					:index="index"
					@handleLinkClick="trackProductClick(product)"
					@loaded="setElements()"
				/>
			</template>
			<template v-else>
				<product-list-item
					v-for="(product, index) in products"
					ref="productElements"
					:key="'list-item' + product.id"
					:product="product"
					:pass="pass"
					:forceShowRelease="forceShowRelease"
					:index="index"
					@handleLinkClick="trackProductClick(product)"
					@loaded="setElements()"
				/>
			</template>
			<loading-spinner v-if="loading" />
			<div class="clearfix" />
		</template>
	</div>
</template>

<script>
import inViewport from 'vue-mixins/in-viewport';
import { prerender } from 'staticData';
import { trackImpression } from 'gtm';
import { mapGetters } from 'vuex';
import { isDesktop } from 'mediaQuery';

// The height of the loading spinner
const LOADING_HEIGHT = 128;

export default {
	mixins: [inViewport],
	props: {
		pageData: {},
		page: {
			type: Number,
		},
		ready: {},
		productListMode: {},
		pageHeight: {},
		lastPage: {
			type: Boolean,
			default: false,
		},
		forceShowRelease: {
			type: Boolean,
			default: false,
		},
		pass: {},
		categoryIcon: {
			type: String,
			default: '',
		},
		productsPerPage: {
			type: Number,
			default: 24,
		},
		pageType: {
			type: String,
			default: '',
		},
		useLoadedHeight: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			hidden: false,
			LIST_MODE_GRID: 2,
			LIST_MODE_COMPACT: 3,
			centerY: 999999,
			height: 0,
			elements: null,
		};
	},
	mounted () {
		this.inViewportMargin = 350;
		this.recalculateInViewport();
		if (this.inViewport) {
			this.requestLoad();
		}
	},
	updated () {
		this.height = this.$el.clientHeight;
	},
	computed: {
		computedHidden () {
			return ! prerender && this.hidden;
		},
		loading () {
			return (this.pageData && this.pageData?.products === null) || (this.pageData?.products?.length > 0 && ! this.elements);
		},
		products () {
			if (! this.pageData || this.pageData.products === null) {
				return [];
			}
			return this.pageData.products;
		},
		style () {
			let activeHeight = this.height;

			/** this.useLoadedHeight is used for when this.page > 1
			 * on the initial page load, so the scroll height for
			 * the entire page is correct
			 */
			if (this.useLoadedHeight) {
				activeHeight = this.pageHeight;
			} else if (this.loading) {
				activeHeight = LOADING_HEIGHT;
			}

			return (this.products.length && ! this.computedHidden) ? {} : {height: activeHeight + 'px'};
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	methods: {
		recalculateHeight () { // @TODO vi behöver inte köra denna på varje sida om vi laddar flera
			const rect = this.$el.getBoundingClientRect();
			const height = rect.bottom - rect.top;
			this.height = height;
			this.$emit('recalculatedHeight', height, this.products.length >= this.productsPerPage);
		},
		requestLoad () {
			/** checks if current component has no products
			 * ready: if parent is reade and there's a currentQuery
			 * lastPage: parent doesn't hasMorePages and page requested is
			 * one more than the max reached page
			 */
			if (! this.products.length && this.ready && ! this.lastPage) {
				this.$emit('request-load');
			}
		},
		recalculateCenterY () {
			this.centerY = this.$el.offsetTop + this.height * .5;
		},
		trackProductClick(product, index) {
			trackImpression([product], this.pageType, {
				rating: true,
				stock: true,
				event: 'select_item',
				position: index
			});
			if (product?.ticket) {
				const data = {
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE'
				};
				waja.get('productdiscovery/click/' + product.ticket).data(data).go();
			}
		},
		/** Helps loading computed to see if the DOM actually
		 * have yet rendered, or else the parent thinks user is
		 * at bottom of page and requests more pages.
		 */
		setElements () {
			this.elements = this.$refs.productElements;
		},
	},
	watch: {
		products (prods) {
			if (! prods || ! this.products.length || this.hidden) {
				return;
			}
			this.$nextTick(() => {
				this.recalculateHeight(); // @TODO also on resize
				this.recalculateCenterY(); // @TODO also on resize
			});
		},
		productListMode () {
			this.$nextTick(() => {
				if (! this.products.length || this.hidden) {
					this.recalculateHeight();
				}
				this.recalculateCenterY();
			});
		},
		inViewport (visible) {
			if (visible) {
				this.hidden = false;
				this.requestLoad();
			} else {
				this.hidden = true;
			}
		},
		ready (ready) {
			this.recalculateInViewport();
			if (this.inViewport) {
				this.requestLoad();
			}
		},
		pageData (pageData) {
			if (! pageData) {
				this.recalculateInViewport();
				if (this.inViewport) {
					this.requestLoad();
				}
			}
		},
	},
};
</script>
